import { parseEther, Address } from 'viem'
import { useAccount } from 'wagmi'
import useSWR from 'swr'
import { LidoSDKWrap } from '@lidofinance/lido-ethereum-sdk'
import { useLidoSDK, useGasFeeUSD } from '.'
import {
  FALLBACK_WRAP_ETH_GAS_LIMIT,
  FALLBACK_WRAP_STETH_GAS_LIMIT,
  ESTIMATE_ACCOUNT,
} from '../constants'
import { useDebounce } from '~/hooks/useDebounce'

const fetchWrapETHGasLimit = async (
  wrap: LidoSDKWrap,
  value: bigint,
  account: Address,
) => {
  return await wrap.wrapEthEstimateGas({
    value,
    account,
  })
}

const fetchWrapStETHGasLimit = async (
  wrap: LidoSDKWrap,
  value: bigint,
  account: Address,
) => {
  return await wrap.wrapStethEstimateGas({
    value,
    account,
  })
}

export const useWrapGasFee = (isETH: boolean, amount: string) => {
  const { address: userAccount } = useAccount()
  const account = (userAccount ?? ESTIMATE_ACCOUNT) as Address
  const { wrap } = useLidoSDK()
  const debouncedAmount = useDebounce(amount || '0.01', 500)
  const formattedAmount = parseEther(debouncedAmount)
  const { data } = useSWR(
    ['lido-wrap-gas-limit', isETH, formattedAmount, account],
    () =>
      isETH
        ? fetchWrapETHGasLimit(wrap, formattedAmount, account)
        : fetchWrapStETHGasLimit(wrap, formattedAmount, account),
    {
      refreshInterval: 60000,
    },
  )
  const fallbackGasLimit = isETH
    ? FALLBACK_WRAP_ETH_GAS_LIMIT
    : FALLBACK_WRAP_STETH_GAS_LIMIT
  const gasLimit = data ?? fallbackGasLimit

  const { gasFee, gasFeeUSD } = useGasFeeUSD(gasLimit)

  return { gasLimit, gasFee, gasFeeUSD }
}
